<template>
  <div>
    <label class="form-label" for="reservation-strategy-select">
      {{ $t('reservationStrategy.name') }}
    </label>
    <TomSelect
      v-model="componentValue.reservationStrategy"
      :options="{
        create: false,
        placeholder: $t('reservationStrategy.select')
      }"
      class="w-full"
    >
      <option
        v-for="reservationStrategyItem in reservationStrategies"
        :value="reservationStrategyItem"
        :key="reservationStrategyItem"
      >
        {{ $t('reservationStrategy.' + reservationStrategyItem.replaceAll('-', '_')) }}
      </option>
    </TomSelect>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { RESERVATION_STRATEGIES } from '@/utils/reservationStrategy'

export default defineComponent({
  props: {
    reservationStrategy: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:reservationStrategy'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.reservationStrategy,
      set: (value) => emit('update:reservationStrategy', value)
    })
    const reservationStrategies = RESERVATION_STRATEGIES

    return {
      componentValue,
      reservationStrategies
    }
  }
})
</script>
